import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./NavBar.css";

function NavBar() {
  console.log(
    "\r\n   _____      _          _____                  \r\n  / ____|    | |        |  __ \\                 \r\n | |     __ _| | _____  | |  | | __ _ _   _ ___ \r\n | |    / _` | |/ / _ \\ | |  | |/ _` | | | / __|\r\n | |___| (_| |   <  __/ | |__| | (_| | |_| \\__ \\\r\n  \\_____\\__,_|_|\\_\\___| |_____/ \\__,_|\\__, |___/\r\n                                       __/ |    \r\n                                      |___/     \r\n\r\nDeveloper : Lakshan Rukantha\r\nGithub : https://github.com/LakshanRukantha"
  );

  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed="top">
      <Container className="NavBar">
        <Navbar.Brand as={Link} to="/">
          Cake Days
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-item">
            <Nav.Link as={Link} className="nav-item" to="/">
              Home
            </Nav.Link>
            <Nav.Link as={Link} className="nav-item" to="/more">
              More
            </Nav.Link>
            <Nav.Link as={Link} className="nav-item" to="/about">
              About
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
